// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"18":"8b62009d","35":"7b27cacc","60":"02f773e8","223":"959f6bba","372":"eb2d7992","871":"af9923bf"}[chunkId] + ".js";
};